import { spacer } from './spacings';

export type FlexContainerPreset = 'form' | 'default';

export type FlexContainerConfig = {
  direction?: 'row' | 'column';
  gap?: string;
};

const PRESET: Record<FlexContainerPreset, FlexContainerConfig> = {
  form: {
    direction: 'column',
    gap: spacer.x3,
  },
  default: {
    direction: 'row',
    gap: spacer.x2,
  },
} as const;

/**
 * returns styles to render specific use case children with even spacing and correct direction
 */
export const flexContainer = (
  preset: FlexContainerPreset = 'default',
  config?: FlexContainerConfig,
): string => {
  const { direction, gap } = { ...PRESET[preset], ...config };
  return `
    display: flex;
    flex-direction: ${direction};
    gap: ${gap};
  `;
};

/**
 * returns styles to center the contents of an element
 */
export const flexCenter = (): string => `
  display: flex;
  align-items: center;
  justify-content: center;
`;
